import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import { FormGroup } from './form-inputs/FormGroup';

export const AgeInput: React.FC<
    {
        value?: number;
        onChange: (_: string) => void;
        suffix?: string;
        maxAge?: number;
    } & React.ComponentProps<typeof FormGroup>
> = ({ value, onChange, maxAge=75, suffix, ...rest }) => {
    return (
        <FormGroup {...rest}>
            <CurrencyInput
                allowNegativeValue={false}
                type="text"
                suffix={` ${suffix}`}
                className={'py-2 px-4 border border-gray-200 rounded-lg focus:outline-none'}
                fixedDecimalLength={0}
                decimalsLimit={2}
                allowDecimals={false}
                value={value ? value : undefined}
                onValueChange={(value = '', _) => onChange(Math.max(0, Math.min(maxAge, +value)) + '')}
            />
        </FormGroup>
    );
};
